<template>
  <div class="info-page">
    <div class="content-card">
      <h2>🛠️ 支援服務 (Support)</h2>
      <p>如果您在使用「港式台牌計番神器」時遇到任何問題，或者有任何建議，請透過以下方式聯絡我們：</p>
      
      <div class="contact-list">
        <div class="contact-item">
          <span class="label">📧 電子郵件：</span>
          <a href="mailto:mahjong@siuheibo.com">mahjong@siuheibo.com</a>
        </div>
        <div class="contact-item">
          <span class="label">💬 Instagram：</span>
          <a href="https://www.instagram.com/siuheibo.app?stkn=Y3RsbDF4NWkyamd1" target="_blank">@siuheibo.app</a>
        </div>
      </div>

      <div class="faq-section">
        <h3>常見問題</h3>
        <div class="faq-item">
          <h4>如何新增自訂規則？</h4>
          <p>進入「設定」頁面，您可以建立新的規則集，並在其中新增不同的番數項目。</p>
        </div>
        <div class="faq-item">
          <h4>資料會同步嗎？</h4>
          <p>如果您登入了帳戶（Google 或 Apple），您的自訂規則將會自動同步到雲端。</p>
        </div>
      </div>

      <button class="back-link" @click="$router.back()">返回</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SupportPage'
}
</script>

<style scoped>
.info-page {
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
}

.content-card {
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
}

h2 {
  color: #2d3748;
  margin-top: 0;
  margin-bottom: 20px;
}

h3 {
  color: #4a5568;
  margin-top: 30px;
  border-bottom: 2px solid #f7fafc;
  padding-bottom: 10px;
}

p {
  line-height: 1.6;
  color: #4a5568;
}

.contact-list {
  background: #f8fafc;
  padding: 15px;
  border-radius: 12px;
  margin: 20px 0;
}

.contact-item {
  margin-bottom: 10px;
}

.contact-item:last-child {
  margin-bottom: 0;
}

.label {
  font-weight: 600;
  color: #2d3748;
}

a {
  color: #4CAF50;
  text-decoration: none;
  font-weight: 500;
}

a:hover {
  text-decoration: underline;
}

.faq-item h4 {
  color: #2d3748;
  margin-bottom: 8px;
}

.faq-item p {
  font-size: 0.95rem;
  margin-top: 0;
}

.back-link {
  margin-top: 30px;
  background: #f0f2f5;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  color: #4a5568;
  cursor: pointer;
  font-weight: 600;
  transition: background 0.2s;
}

.back-link:hover {
  background: #e2e8f0;
}
</style>
